import React from 'react'
import PropTypes from 'prop-types'
import VoicemailIcon from '../../assets/VoicemailIcon'

const VoicemailButtonBox = ({ onClick, voicemail, showVoicemail }) => (
  <div
    className="voicemaiButtonBox"
  >
    {
      voicemail &&
      <div
        className="voicemailIconButton"
        onClick={onClick}
        role="button"
        tabIndex="-1"
      >
        <VoicemailIcon />
        <span>{ showVoicemail ? 'See less -' : 'See more +' }</span>
      </div>
    }
  </div>
)

VoicemailButtonBox.propTypes = {
  onClick: PropTypes.func.isRequired,
  voicemail: PropTypes.object,
  showVoicemail: PropTypes.bool.isRequired,
}

export default VoicemailButtonBox



// WEBPACK FOOTER //
// ./src/components/CallLog/CallLogPage/VoicemailButton.js